import paymentIcon from "../../../../../../assets/paymentIcon.png";
import closeIcon from "../../../../../../assets/closeIcon.png";
import TableAddNewpayments from "../../../../../../components/TableAddNewPayments";
import { useNavigate, useParams } from "react-router-dom";

const NovoPagamento = () => {
  const { id } = useParams();
  const navigate = useNavigate(); // Hook para navegação

  const handleNavigate = () => {
    navigate(`/pedidos/detalhes/${id}`);
  };

  return (
    <div className="bg-extraLightGray rounded-md p-5 relative flex-1 h-full flex-grow justify-between flex-col flex">
      <img
        src={closeIcon}
        alt="Ícone para fechar"
        className="w-[30px] h-[30px] absolute top-3 right-3 cursor-pointer"
        onClick={handleNavigate}
      />
      <div className="mx-8">
        <div className="flex items-center border-b border-lightGray pb-4">
          <img
            src={paymentIcon}
            alt="ícone de pagamento"
            className="w-[60px] h-[60px] ml-2"
          />
          <h2 className="ml-10 text-2xl font-semibold">
            Adicionar Novo Pagamento
          </h2>
        </div>

        <TableAddNewpayments />
      </div>
    </div>
  );
};

export default NovoPagamento;
